import { defineMessages } from 'react-intl';

export default defineMessages({
  newHF: { defaultMessage: 'New health factor' },
  safer: { defaultMessage: 'Safer' },
  riskier: { defaultMessage: 'Riskier' },
});
